import Gradient, { DEFAULT_GRADIENT_ID, GRADIENT_IDS } from './svg-gradient.component'
import SVG from './svg.component'

export { Gradient, DEFAULT_GRADIENT_ID, GRADIENT_IDS }
export default SVG
